"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "What's the problem that you want to solve now? We suggest using the problem you identified in problem identification exercise.",
  type: "textarea",
  meta: {
    answerLabel: "My problem is...",
    summaryTitle: "The problem which you want to solve",
    placeholderText: "Example: I'm so hard on myself."
  },
  batteryId: "PROBLEM_SOLUTION"
}, {
  prompt: "Write down some solutions as you can think of for your problem",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "Solutions for this problem that you can think of",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_SOLUTION"
}, {
  prompt: "Rank your solutions from best to worst to find your top solutions. Write the best ones first.",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "Ranked solutions for this problem",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_SOLUTION"
}, {
  prompt: "If you get stuck when ranking, write down at least one Pro and one Con for each solution then rank your solutions",
  type: "textarea",
  meta: {
    answerLabel: "This is a problem because...",
    summaryTitle: "Pros and cons for each solution",
    placeholderText: "Example: It's not healthy."
  },
  batteryId: "PROBLEM_SOLUTION"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      return {
        question: question,
        answer: answers[question.batteryId][index]
      };
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;